<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { required, email } from '@validations';
import axios from '@/libs/axios';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';

export default {
  components: {
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        alcadaid: '',
        tipousuarioid: '',
        valorde: '',
        valorate: '',
        tipoalcadaid: '',
      }),
      require: true,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    isRangeValid() {
      const valorde = parseInt(this.dataForm.valorde, 10);
      const valorate = parseInt(this.dataForm.valorate, 10);

      if (isNaN(valorde) || isNaN(valorate)) {
        return true;
      }

      return valorde <= valorate;
    },
  },
  data() {
    return {
      dataFromApiTipoUsuarioId: '',
      rangeError: false,
    };
  },
  mounted() {
    this.fetchDataFromUsuario();
  },
  methods: {
    async validateForm() {
      if (!this.isRangeValid) {
        this.rangeError = true;
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro de validação',
            text: 'O valor de não pode ser maior que o valor até.',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
        return;
      }

      this.rangeError = false;

      if (!this.dataForm.tipousuarioid || !this.dataForm.valorde || !this.dataForm.valorate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Formulário incompleto',
            text: 'Selecione todos os valores obrigatórios.',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        return;
      }

      this.$emit('ok', this.dataForm);
      this.$bvModal.hide(this.idModal);
    },
    async fetchDataFromUsuario() {
      try {
        const response = await axios.get('/perfilAcesso/findAll');
        this.dataFromApiTipoUsuarioId = response.data.data.filter(
          (perfil) => perfil.perfil_acesso_ativo === 1,
        );
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    checkRangeValues() {
      this.rangeError = false;
    },
  },
  watch: {
    'dataForm.valorde': function () {
      this.checkRangeValues();
    },
    'dataForm.valorate': function () {
      this.checkRangeValues();
    },
  },
};
</script>

<template>
  <b-modal no-close-on-backdrop no-close-on-esc size="md" :id="idModal" :title="titleModal"
    :ok-disabled="dataForm.isDefault || !dataForm.tipousuarioid || !dataForm.valorde || !dataForm.valorate || !isRangeValid"
    :ok-title="labelBtnOk" ok-variant="success" cancel-variant="secondary" body-bg-variant="light"
    cancel-title="Cancelar" @ok="validateForm" @cancel="$emit('cancel')" @close="$emit('cancel')">
    <validation-observer ref="refFormData">
      <b-form @submit.prevent>
        <b-row>
          <b-col cols="12" class="mb-1">
            <b-form-group label="Tipo Usuario" label-for="alcadaid">
              <validation-provider #default="{ errors }" name="Tipo Usuário" rules="required">
                <b-form-select v-model="dataForm.tipousuarioid" id="alcadaid" :state="errors.length > 0 ? false : null"
                  :options="dataFromApiTipoUsuarioId" value-field="id" text-field="perfil_acesso_nome"
                  placeholder="Digite o id" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12" class="mb-1">
            <b-form-group label="Valor de" label-for="valorde">
              <validation-provider #default="{ errors }" name="Valor de" rules="required|regex:^([0-9]+)$">
                <b-form-input v-model="dataForm.valorde" id="valorde" v-mask="'##########'"
                  :state="errors.length > 0 ? false : null" :disabled="dataForm.isDefault" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12" class="mb-1">
            <b-form-group label="Valor Até" label-for="valorate">
              <validation-provider #default="{ errors }" name="Valor Até" rules="required|regex:^([0-9]+)$">
                <b-form-input v-model="dataForm.valorate" id="valorate" v-mask="'##########'"
                  :state="errors.length > 0 ? false : null" :disabled="dataForm.isDefault" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
              <small v-if="rangeError || (!isRangeValid && dataForm.valorde && dataForm.valorate)" class="text-danger">
                O valor de não pode ser maior que o valor até.
              </small>
            </b-form-group>
          </b-col>
          <b-col cols="12" class="mb-1" hidden>
            <b-form-group label="tipoalcadaid" label-for="tipoalcadaid">
              <validation-provider #default="{ errors }" name="valorate" rules="required">
                <b-form-input v-model="dataForm.tipoalcadaid" value="2" id="tipoalcadaid"
                  :state="errors.length > 0 ? false : null" :disabled="dataForm.isDefault" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
